import React from 'react';
import { graphql, createRefetchContainer } from 'react-relay';

import { withRouter } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import InnerTabFilterGridItemDateField from '../common/innerTab/InnerTabFilterGridItemDateField';
import TableStatus from '../common/TableStatus';
import TablePaginator from '../common/TablePaginator';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import InnerTabFilterToggleButtonGroup from '../common/innerTab/InnerTabFilterToggleButtonGroup';
import RTTableRenderer from '../common/table/RTTableRenderer';
import BrokerActivityTableFieldMeta from '../activityIB/BrokerActivityTableFieldMeta';
import PendingTxnSelectionCell from './pendingTransaction/PendingTxnSelectionCell';
import { AddButton } from '../common/buttons/BaseButton';
import { doCommitPromise } from '../../common/commit';
import createClearstreamCashTransferPreAdviseFile from '../../mutations/clearstream/CreateClearstreamCashTransferPreAdviseFile';
import { deepCoalesce } from '../../common/helpers';
import BrokerActivityActions from '../activityIB/BrokerActivityActions';
import BrokerActivityDetails from '../activity/BrokerActivityDetails';

const ignoreDefault = false;

function CSPendingTransactionList(props) {
  const { viewer, relay, filter } = props;
  filter.setRelay(relay);
  const [selectionSet, setSelectionSet] = React.useState([]);
  const classes = useCommonStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [detailsOpen, setDetailsOpen] = React.useState(false);
  const [brokerActivity, setBrokerActivity] = React.useState(null);
  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.field('quantity', 'Quantity', {
      align: 'right',
      width: 120,
    }),
    BrokerActivityTableFieldMeta.currency,
    TableFieldMeta.field('proceeds', 'Proceeds', {
      align: 'right',
      width: 180,
    }),
    TableFieldMeta.field('requestedAmount', 'Req. Amount', {
      align: 'right',
      width: 180,
    }),
    TableFieldMeta.field('price', 'Price', { align: 'right', width: 80 }),
    BrokerActivityTableFieldMeta.reportDate,
    TableFieldMeta.field('settlementDate', 'Settle Date', {
      width: 90,
      align: 'center',
    }),
    TableFieldMeta.field(
      node => (node.ignore ? (
        <TableStatus>Ignore</TableStatus>
      ) : (
        <TableStatus secondary>UnIgnore</TableStatus>
      )),
      'Ignored',
    ),
    TableFieldMeta.createdAt,
    // BrokerActivityTableFieldMeta.ignore(msgRouter),
    TableFieldMeta.fieldCell('selection', '', row => (
      <PendingTxnSelectionCell
        pendingTransaction={row.value}
        selectionSet={selectionSet}
        setSelectionSet={setSelectionSet}
      />
    ), { align: 'center', width: 50, accessor: x => x }),
    TableFieldMeta.fieldCell('paFile', 'Pre Advise File', (row) => {
      if (!deepCoalesce(row.value, ['brokerOrder', 'transferAdviceFile'])) {
        return null;
      }
      const ptFile = row.value.brokerOrder.transferAdviceFile;
      return <Link href={ptFile.csvUrl}>{ptFile.csv.split('/')[2]}</Link>;
    }, { accessor: x => x, width: 200, align: 'center' }),


    {
      id: 'actions',
      accessor: node => node,
      Header: '',
      Cell: row => (
        <BrokerActivityActions
          brokerActivity={row.value}
          onProcess={(be) => {
            setBrokerActivity(be);
            setDrawerOpen(true);
          }}
          onShowDetails={(be) => {
            setBrokerActivity(be);
            setDetailsOpen(true);
          }}
        />
      ),
    },

  ];

  return (
    <div className={classes.innerTabRoot}>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <div tabIndex={0} role="button">
          {/*<ProcessForm brokerActivity={brokerActivity} close={() => setDrawerOpen(false)} />*/}
        </div>
      </Drawer>

      <Drawer anchor="right" open={detailsOpen} onClose={() => setDetailsOpen(false)}>
        <div
          tabIndex={0}
          role="button"
        >
          <BrokerActivityDetails brokerActivity={brokerActivity} />
        </div>
      </Drawer>

      <BaseGridContainer>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <InnerTabFilterGridItemTextField
              id="search-filter"
              label="Custom Search"
              defaultValue={filter.params.search}
              helperText="description, symbol"
              onChange={e => filter.updateVar('search', e.target.value)}
            />

            <InnerTabFilterGridItemDateField
              value={filter.params.reportDate}
              onChange={value => filter.updateVar('reportDate', value)}
              label="Report Date"
            />

            <InnerTabFilterToggleButtonGroup
              enumType={[
                { name: null, description: '∅' },
                { name: false, description: 'Yes' },
                { name: true, description: 'No' },
              ]}
              helperText="Processed?"
              defaultValue={filter.params.processedAt_Isnull || null}
              onChange={newVal => filter.updateVar('processedAt_Isnull', newVal)}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <AddButton
                disabled={selectionSet.length === 0}
                buttonText="Pre Advised File"
                onClickPromise={() => doCommitPromise(
                  createClearstreamCashTransferPreAdviseFile,
                  { pendingTransactionIds: selectionSet.map(x => x.id) },
                  () => {
                    filter.update();
                    setSelectionSet([]);
                  },
                  () => null,
                )
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TablePaginator
            filter={filter}
            columns={columns}
            getDataNode={() => (viewer ? viewer.clearstreamPendingTransactions : null)
            }
            tableRender={RTTableRenderer}
          />
        </Grid>
      </BaseGridContainer>
    </div>
  );
}

const query = graphql`
  query CSPendingTransactionListQuery(
    $first: Int
    $offset: Int
    $search: String
    $reportDate: Date
    $ignored: Boolean
    $processedAt_Isnull: Boolean
  ) {
    viewer {
      ...CSPendingTransactionList_viewer
        @arguments(
          first: $first
          offset: $offset
          search: $search
          reportDate: $reportDate
          ignored: $ignored
          processedAt_Isnull: $processedAt_Isnull
        )
    }
  }
`;

const container = createRefetchContainer(
  CSPendingTransactionList,
  {
    viewer: graphql`
      fragment CSPendingTransactionList_viewer on Query
        @argumentDefinitions(
          first: { type: Int, defaultValue: 10 }
          offset: { type: Int }
          search: { type: String }
          reportDate: { type: Date }
          ignored: { type: Boolean }
          processedAt_Isnull: { type: Boolean }
        ) {
        clearstreamPendingTransactions(
          first: $first
          offset: $offset
          search: $search
          reportDate: $reportDate
          ignored: $ignored
          orderBy: "-createdAt"
          processedAt_Isnull: $processedAt_Isnull
        ) {
          edges {
            node {
              brokeractivityPtr {
                id
                group {
                  id
                  description
                }
                
                brokeractivitytransactionSet {
                  edges {
                    node { 
                      id

                      account {
                        id
                        name
                      }
                      
                      brokeractivitytransactioncashdeltaSet {
                        edges {
                          node {
                            id
                            currency
                            quantity
                            
                            portfolio {
                              id
                            }
                          }
                        }
                      }
                      
                      brokeractivitytransactioncontractdeltaSet {
                        edges {
                          node {
                            id
                            portfolio {
                              id
                            }
                            contract {
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              id
              createdAt
              updatedAt
              reportDate
              processedBy {
                id
                fullName
              }
              processedAt
              ignored
              yourReference
              isin
              status
              settlementDate
              requestedAmount
              quantity
              currency

              brokerOrder {
                transferAdviceFile {
                  id
                  csvUrl
                  csv
                }
              }
            }
          }
          count
        }
      }
    `,
  },
  query,
);

export default withRouter(
  createQueryRendererProgressV2(
    query,
    container,
    {},
    () => ({
      search: null,
      reportDate: null,
      ignored: ignoreDefault,
    }),
    {
      debounceFields: ['search'],
    },
  ),
);
